var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLodge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.462 4.198a.83.83 0 0 1 1.076 0l9.167 7.778a.832.832 0 1 1-1.076 1.27l-.851-.722V19A2.777 2.777 0 0 1 18 21.778H8A2.777 2.777 0 0 1 5.222 19v-6.476l-.85.723a.833.833 0 0 1-1.078-1.271l9.168-7.778zM6.889 11.11V19A1.11 1.11 0 0 0 8 20.111h10A1.11 1.11 0 0 0 19.111 19v-7.889l-6.11-5.185-6.112 5.185z",
    fill: "#1A202C",
    fillRule: "nonzero",
    stroke: "#1A202C",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLodge);
export default __webpack_public_path__ + "static/media/icon-lodge.8b3c8cf9.svg";
export { ForwardRef as ReactComponent };